import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@spartacus/core';
import { provideDefaultConfig } from '@spartacus/core';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Default Google Tag Manager collector.
 */
let GtmCollectorService = /*#__PURE__*/(() => {
  class GtmCollectorService {
    constructor(winRef) {
      this.winRef = winRef;
    }
    /**
     * If the `TmsCollectorConfig.dataLayerProperty` is not specified, it uses the default `dataLayer`
     */
    init(config, windowObject) {
      const dataLayerProperty = config.dataLayerProperty ?? 'dataLayer';
      windowObject[dataLayerProperty] = windowObject[dataLayerProperty] ?? [];
      if (config.gtmId) {
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
          const f = d.getElementsByTagName(s)[0];
          const j = d.createElement(s);
          const dl = l !== 'dataLayer' ? '&l=' + l : '';
          j.async = true;
          j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
          f.parentNode?.insertBefore(j, f);
        })(windowObject, this.winRef.document, 'script', dataLayerProperty, config.gtmId);
      }
    }
    pushEvent(config, windowObject, event) {
      const dataLayerProperty = config.dataLayerProperty ?? 'dataLayer';
      windowObject[dataLayerProperty].push(event);
    }
    static {
      this.ɵfac = function GtmCollectorService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GtmCollectorService)(i0.ɵɵinject(i1.WindowRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: GtmCollectorService,
        factory: GtmCollectorService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return GtmCollectorService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultGoogleTagManagerConfig = {
  tagManager: {
    gtm: {
      collector: GtmCollectorService
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let GtmModule = /*#__PURE__*/(() => {
  class GtmModule {
    static {
      this.ɵfac = function GtmModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || GtmModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: GtmModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig(defaultGoogleTagManagerConfig)]
      });
    }
  }
  return GtmModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GtmCollectorService, GtmModule };
